import { render } from "./Burger.vue?vue&type=template&id=777d507a&scoped=true"
import script from "./Burger.vue?vue&type=script&lang=js"
export * from "./Burger.vue?vue&type=script&lang=js"

import "./Burger.vue?vue&type=style&index=0&id=777d507a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-777d507a"

export default script